<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 轮播 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
            <img class="swiper-lazy" :data-src="item.advertiseImgUrl" >
            <div class="swiper-lazy-preloader"></div>
            <!-- <div class="swiper-slide-title">
                <h1>{{item.title}}</h1>
                <p>{{item.content}}</p>
            </div> -->
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div> -->
      </div>
    </div>
    <div class="nav-header-box ">
      <!-- 电脑导航 -->
      <div class="header-nav container hidden-sm hidden-xs">
        <!-- 导航logo -->
        <div class="header-nav-logo">
          <img src="@/assets/img/logo.png">
        </div>
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.nameCn)">
            <router-link :to="item.url">
              {{ item.nameCn }}
              <!-- <span v-if="item && item.children.length > 0" class="glyphicon glyphicon-menu-down"></span> -->
              <!-- <i class="underline"></i> -->
            </router-link>
            <dl v-if="item && item.children.length > 0">
              <dt class="sub-item" v-for="(i, n) in item.children" :key="n"  @click="handleNameChange(i.nameCn)">
                <router-link class="sub-title" :to="i.url" >{{ i.nameCn }}</router-link>
              </dt>
            </dl>
          </li>
          <div class="heaer-menu-item">
            <img class="header-menu-img" src="@/assets/img/header/search.png" data-toggle="collapse" data-target="#menu" @click="searchVisible = !searchVisible" />
            <img class="header-menu-img" src="@/assets/img/header/msg.png" alt="logo">
            <div class="search-box" v-if="searchVisible">
              <input type="text" v-model="searchText" placeholder="请输入搜索内容" class="search-input" />
              <i class="iconfont icon-sousuo_o" @click="handleSearch"></i>
            </div>
          </div>
        </ul>

      </div>


      <!-- 手机导航 -->
      <div class="header-nav-m container-fuild visible-sm visible-xs">
        <div class="header-nav-m-logo">
          <img class="center-block" src="@/assets/img/logo.png" alt="logo">
        </div>
        <!-- 导航栏 -->
        <div class="header-nav-m-menu text-center">
          <!-- {{ menuName }} -->
          <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
            <!-- <span :class="menuClass"></span> -->
            <img class="header-menu-img" src="@/assets/img/header/menu.png" alt="logo">
          </div>
          <div class="heaer-menu-item">
            <img class="header-menu-img" src="@/assets/img/header/search.png" data-toggle="collapse" data-target="#menu" @click="searchVisible = !searchVisible">
            <img class="header-menu-img" src="@/assets/img/header/msg.png">
            <div class="search-box" v-if="searchVisible">
              <input type="text" v-model="searchText" placeholder="请输入搜索内容" class="search-input"/> 
              <i class="iconfont icon-sousuo_o" @click="handleSearch"></i>
            </div>
          </div>
          <!-- 导航内容 -->
          <ul id="menu" class="header-nav-m-wrapper collapse" v-if="false">
            <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
              @click="navClick(index, item.nameCn)" data-toggle="collapse" data-target="#menu">
              <router-link :to="item.url">
                {{ item.nameCn }}
                <!-- <i class="underline"></i> -->
                <span v-if="item && item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
              </router-link>
              <dl v-if="item && item.children.length > 0">
                <dt class="sub-item" v-for="(i, n) in item.children" :key="n" @click="handleNameChange(i.nameCn)">
                  <router-link class="sub-title" :to="i.url" >{{ i.nameCn }}</router-link>
                </dt>
              </dl>
            </li>
          </ul>
          <el-collapse v-model="activeName" id="menu" class="header-nav-m-wrapper collapse">
            <el-collapse-item :title="item.nameCn" v-for="(item, index) in navList" :key="index"
              :class="index == navIndex ? 'active' : ''" @click="navClick(index, item.name)" :name="index">
              <template slot="title">
                <div class="collapse-title" data-toggle="collapse" data-target="#menu" @click="activeName = []">
                  <router-link :to="item.url">
                    {{ item.nameCn }}
                    <!-- <i class="underline"></i> -->
                    <!-- <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span> -->
                  </router-link>
                </div>
              </template>
              <div v-if="item && item.children.length > 0">
                <div class="collapse-sub-title sub-item" v-for="(i, n) in item.children" :key="n" data-toggle="collapse"
                  data-target="#menu" @click="activeName = []">
                  <router-link class=" sub-title" :to="i.url"><span>· </span>{{ i.nameCn }}</router-link>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from 'wowjs';
import api from '../api/api'; // 这里替换成实际的模块文件名

export default {
  name: "Header",
  data() {
    return {
      activeName: [],
      swiperList: [
        // {
        //   img: require("@/assets/img/banner1.png"),
        //   path: "",
        //   title: '您身边的IT专家1',
        //   content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        // },
        // {
        //   img: require("@/assets/img/banner2.jpg"),
        //   path: "",
        //   title: '您身边的IT专家2',
        //   content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        // },
        // {
        //   img: require("@/assets/img/banner1.png"),
        //   path: "",
        //   title: '您身边的IT专家3',
        //   content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        // },
        // {
        //   img: require("@/assets/img/banner2.jpg"),
        //   path: "",
        //   title: '您身边的IT专家4',
        //   content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        // }
      ],
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        // {
        //   name: "首页",
        //   path: "/",
        //   children: []
        // },
        // {
        //   name: "关于校友会",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "智能小镇管理系统",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "大数据管理系统",
        //       path: "/software/bigData"
        //     }
        //   ]
        // },
        // {
        //   name: "机构建设",
        //   path: "/branchConstruction",
        //   children: []
        // },
        // {
        //   name: "校友故事",
        //   path: "/alumniStories",
        //   children: []
        // },
        // {
        //   name: "通知公告",
        //   path: "/branchConstruction",
        //   children: []
        // },
        // {
        //   name: "资源中心",
        //   path: "/resourceCentre",
        //   children: []
        // },
        // {
        //   name: "留言咨询",
        //   path: "/message",
        //   children: []
        // }
      ],
      searchText: '',
      searchVisible: false,
      isMobile: false,
      lastWidth: window.innerWidth

    };
  },
  mounted() {
    // this.checkMobile(); // 初始检查
    // window.addEventListener('resize', this.checkMobile);

    this.activeName = []
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();
    this.getData()
  },
  methods: {
    getData() {
      api.getWebClassList({ "siteId": 38960498268485 }).then((res) => {
        res.result.map(item => {
          item.children = item.children || []
        })
        // console.log(res, 'nav');

        this.navList = res.result;
      }).catch((error) => {
        console.error(error);
      });

      // banner
      api.getWebAdvertiseList({
        "page": 1,
        "pageSize": 10,
        "siteId": 38960498268485
      }).then((res1) => {
        // console.log(res1,'banner');
        this.swiperList = res1.result.items;
      })

    },
    handleResize() {
      const newWidth = window.innerWidth;
      if (newWidth < 768 && this.lastWidth >= 768) {
        // 假设宽度小于768px是手机屏幕，大于768px是宽屏
        // 在这里执行重新加载逻辑
        console.log('现在是手机屏幕，触发重新加载');
        // 可以使用路由守卫或者全局事件来触发页面重新加载
        // this.$router.replace('/').catch(err => {}); // 如果使用vue-router
        // this.$emit('reload'); // 如果使用全局事件
      }
      this.lastWidth = newWidth;
    },
    navClick(index, name) {
      // console.log('navclick', name)
      localStorage.setItem('title', name)
      // document.title=name
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
      this.activeName = []
    },
    handleNameChange(name){
      // console.log('navclick', name)
      localStorage.setItem('title', name)
      document.title=name
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
      this.searchVisible=false
    },
    handleSearch() {
      this.searchVisible = false
      this.$router.push({ path: '/search', query: { searchText: this.searchText } })
    }
  }
};
</script>
<style lang="scss" scoped>
/* 轮播图 */
#swiper {
  height: 600px;
  position: relative;
  background: #ededed;

  .banner-swiper {
    width: 100%;
    height: 100%;

  }


  .swiper-slide {
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .swiper-slide-title {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999999999;
    width: 100%;
    height: 100%;
    color: #fff;
    background: rgba(51, 51, 51, 0.534);
    text-align: center;
    line-height: 80px;
  }

  .swiper-slide-title>h1 {
    font-size: 50px;
    margin-top: 12%;
  }

  .swiper-slide-title>p {
    font-size: 20px;
    margin-top: 1%;
    font-weight: 700;
  }
}

.nav-header-box {
  position: absolute;
  top: 0;
  left: 100px;
  z-index: 9999;
}


/* 顶部 */
#header {
  /* background: #f4f4f4; */
  transition: all ease 0.6s;
  position: relative;
  top: 0;
  z-index: 999;
  width: 100%;
}

/* 导航栏 */
#header .header-nav {
  padding: 0px!important;
  height: 110px;
  min-width: 1260px!important;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  /* width: 100px; */
  height: 100%;
  float: left;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  /* width: 95px; */
  height: 50px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;

}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  // max-width: 800px;

  .heaer-menu-item {
    margin-top: 25px !important;
    position: relative;

    img {
      &:first-child {
        margin-left: 60px;
      }
    }



  }
}

.search-box {
  width: 260px;
  height: 40px;
  border-radius: 5px;
  background-color: #ffff;
  position: absolute;
  right: 40px;
  top: 60px;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 0 5px;

  input {
    height: 40px;
    width: 100%;
    // background-color: #fff;
    padding: 0px;
    border: none;
    color: #000;
  }

  i {
    color: #D30A1D;
  }
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #D30A1D;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #fffc79;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  // color: #D30A1D;
  text-decoration: none;
  // border-bottom: 2px solid #D30A1D;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

.sub-title {
  color: #666 !important;

  &:hover {
    color: #D30A1D !important;
  }
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  color: #D30A1D !important;
  /* border-bottom: 1px solid #ccc; */
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  color: #D30A1D !important;
}

.sub-item {
  padding: 10px;

  &:hover {
    color: #D30A1D !important;
  }
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
  background-color: #fff;
  border-radius: 5px;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  /* background: #ccc; */
  color: #D30A1D;
}

.heaer-menu-item {
  display: flex;
  align-items: center;
  position: relative;
}

.header-menu-img {
  width: 35px;
  height: 35px;
  margin-right: 20px;
  margin-top: 10px;

}

/*  媒体查询（手机） */

@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }

  .nav-header-box {
    width: 100%;
    left: 0;
    // background-color: red!important;
  }

  #header .header-nav-m {
    position: relative;
    width: 100%;

  }

  .search-box {
    top: 50px;
    right: 20px;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  .header-menu-img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    margin-left: 0px;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    // width: 95px;
    height: 35px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // margin: auto;
    margin-left: 10px;
    margin-top: 10px;

  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    // width: 30px;
    width: 20%;
    height: 30px;
    font-size: 10px;
    line-height: 50px;
    // background: #474747;
    position: absolute;
    top: 0px;
    right: 0px;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: -5px;
    right: 80px;
    // margin-top: -20px;
    // width: 50px;
    height: 50px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    width: 300px !important;
    position: absolute;
    top: 50px;
    left: -280px;
    width: 100%;
    background: #fff;
    color: #333 !important;
    z-index: 9999999;
    padding: 10px;

    a {
      color: #333333 !important;
    }

    .collapse-sub-title {
      text-align: left !important
    }
  }

  .glyphicon {
    color: #fff !important;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    color: #333 !important;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #333 !important;
    font-size: 10px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  #swiper {
    height: 400px;
  }

  .nav-header-box {

    width: 100% !important;
    left: 0px !important;
    // background-color: red !important;

    .header-nav-m-menu-wrapper {
      right: 160px !important;
    }

    .heaer-menu-item img {
      margin-left: 0px !important;
    }

    .header-nav-wrapper>li {
      margin: 0px 11px !important;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 997px) {


  #header .header-nav-m {
    position: relative;
    width: 100%;

  }

  .search-box {
    top: 50px;
    right: 20px;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  .header-menu-img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    margin-left: 0px;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    // width: 95px;
    height: 35px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // margin: auto;
    margin-left: 10px;
    margin-top: 10px;

  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    // width: 30px;
    width: 20%;
    height: 30px;
    font-size: 10px;
    line-height: 50px;
    // background: #474747;
    position: absolute;
    top: 0px;
    right: 0px;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: -5px;
    right: 80px;
    // margin-top: -20px;
    // width: 50px;
    height: 50px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    width: 300px !important;
    position: absolute;
    top: 50px;
    left: -280px;
    width: 100%;
    background: #fff;
    color: #333 !important;
    z-index: 9999999;
  }

  .glyphicon {
    color: #fff !important;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    color: #333 !important;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #333 !important;
    font-size: 10px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue